import { AppSportsBookState } from 'src/domains/sportsbook/state/AppSportsBook.state';
import React from 'react';
import { BettingTab } from 'src/domains/sportsbook/betting/bettingTab/BettingTab';
import { CustomScrollbar } from 'src/domains/players/webview/components/Account/accountPanel/customScrollbar/CustomScrollbar';
import {
    AccountContentWrapperDesktop,
    ScrollbarWrapper,
} from 'src/domains/players/webview/components/Account/accountParts/Account.style';
import { AccountNavigation } from 'src/domains/players/webview/components/Account/accountPanel/accountNavigation/AccountNavigation';
import { observer } from 'src/utils/mobx-react';
import { MiniGames } from 'src/domains/casino/webview/CasinoGames/mini-games/MiniGames';
import { NotificationsList } from 'src/domains/layouts/webview/components/notificationsList/NotificationsList';
import { RouteViewType } from 'src/domains/layouts/state/router/newRouter/mainRouteTypes';
import { TwitterWidget } from 'src/domains/layouts/webview/components/twitterWIdget/TwitterWidget';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { FeatureState } from 'src/domains/layouts/config/features/featureState/FeatureState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface PropsType {
    currentView: RouteViewType | null;
    isNotificationsList: boolean;
}

export const BetsPanel = observer('BetsPanel', (props: PropsType): JSX.Element | null => {
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const featureState = FeatureState.get(common);
    const configComponents = ConfigComponents.get(common);

    const isCasino = props.currentView?.name === 'casino';
    const isVirtuals = props.currentView?.name === 'virtuals';
    const isLiveCasino = props.currentView?.name === 'live-casino';

    const isAnyCasinoPage = isCasino || isVirtuals || isLiveCasino;

    const appSportsBookState = AppSportsBookState.get(common);
    const { casinoMiniGames, socialWidgets } = configComponents.config;
    const { betWidgetsState } = appSportsBookState;
    const { isIndicatorVisible } = betWidgetsState;
    const isAllowCasinoInIOSWrapper = featureState.allowCasinoInIOSWrapperNew;

    const isTwitterWidgetNotVisible = isAnyCasinoPage || isIndicatorVisible;

    const isDesktop = breakpointsState.desktop.isBiggerOrEq === true;
    const isClosing =
        configComponents.config.closureModeWithLogin ||
        configComponents.config.closureMode ||
        configComponents.config.midnightMigrationScreen;

    return (
        <AccountContentWrapperDesktop>
            <AccountNavigation currentView={props.currentView} />
            {isClosing ? null : (
                <ScrollbarWrapper>
                    <CustomScrollbar>
                        {isCasino === false && isVirtuals === false && isDesktop === true ? (
                            <>
                                <BettingTab key='betting-tab' />
                                {casinoMiniGames && isAllowCasinoInIOSWrapper === true ? <MiniGames /> : null}
                            </>
                        ) : null}

                        {socialWidgets.twitter === null ? null : (
                            <TwitterWidget
                                isWidgetNotVisible={isTwitterWidgetNotVisible}
                                socialWidgetData={socialWidgets.twitter}
                            />
                        )}

                        <NotificationsList
                            key='notifications-list'
                            isNotificationsList={props.isNotificationsList}
                        />
                    </CustomScrollbar>
                </ScrollbarWrapper>
            )}
        </AccountContentWrapperDesktop>
    );
});
